export default "__VITE_ASSET__BiARqLjY__"